<template>
  <div style="position: relative; height: 100%; width: 100%">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js";

export default {
  props: {
    chartData: {
      type: Array, // Expected: Array of objects or values. For simplicity, let's assume [10, 20, ...] or labels logic
      default: () => []
    },
    labels: {
        type: Array,
        default: () => []
    }
  },
  data: () => ({
    chart: null
  }),
  mounted() {
    this.renderChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  watch: {
    chartData: {
      handler() {
        if (this.chart) {
            this.chart.destroy();
        }
        this.renderChart();
      },
      deep: true
    }
  },
  methods: {
    renderChart() {
      const ctx = this.$refs.canvas.getContext("2d");
      
      const palette = [
        '#FF4600', '#3B82F6', '#10B981', '#8B5CF6', '#F59E0B', 
        '#EC4899', '#06B6D4', '#14B8A6', '#F43F5E', '#84CC16', 
        '#6366F1', '#F97316', '#A855F7', '#EAB308', '#059669'
      ];
      const colors = this.chartData.map((_, index) => {
          return palette[index % palette.length];
      });

      this.chart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: this.labels,
          datasets: [
            {
              data: this.chartData,
              backgroundColor: colors,
              borderWidth: 0,
              // cornerRadius logic often requires a plugin in Chart.js 2, 
              // but we can try basic config or just rely on CSS masking if needed, 
              // or just accept square bars for 2.9 without plugins.
              // However, barThickness works.
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          tooltips: {
              enabled: true,
              mode: 'index',
              intersect: false,
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false,
                drawBorder: false
              },
              barThickness: 32, // Moderately thick
              ticks: {
                  display: true, 
                  autoSkip: false,
                  maxRotation: 45,
                  minRotation: 45,
                  fontColor: '#9ca3af',
                  fontSize: 10
              }
            }],
            yAxes: [{
              display: false, // Remove Y axis as requested
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                  display: false
              }
            }]
          }
        }
      });
    }
  }
};
</script>
